import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import {
  gridStyles,
  gridComponents,
} from "../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { editCellContainerStyle } from "../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { saveOrDeleteMsg } from "../../../edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import moment from "moment";
import {
  ActionsCellComponent,
  StatusCellComponent,
} from "../paymentGatewaysConfiguration/common";
import { ReactComponent as CloseIcon } from "../../../../../../assets/img/svg/CloseSquareBlack.svg";
import ALoader from "views/pages/manage/common/a-loader";
import NoRowOverlay from "../../holidayMaster/NoRowOverlay";
import {
  isObjEmpty,
  generateRandomId,
} from "../../../common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";
import {
  applicationLevelToggleOptions,
  dateControlDropdown,
  newRow,
} from "./constants";
import { regex } from "views/pages/manage/common/constant";
import { Tooltip } from "@mui/material";
import { ReactComponent as EyeIcon } from "../../../../../../assets/img/svg/eyeIcon.svg";
import AToggleButton from "../../../../../../components/AToggleButton";
import AButton from "../../../common/form-fields-mui/AButton";
import AddApplicationListPopup from "./AddApplicatonListPopup";

export const defaultStatusStyle = {
  color: "#0B442D",
  padding: "4px 11px",
  fontSize: "12px",
  borderRadius: "8px",
  fontWeight: "400",
  backgroundColor: "rgb(187, 226, 206)",
  // marginLeft : '8px'
};

const ListComponent = (
  {
    rows = [],
    loading,
    setLoading,
    currentPage,
    totalRecords,
    pageChangeHandler,
    dropdownData,
    createUpdateHandler,
    forPANIndia,
  },
  ref,
) => {
  const [rowModesModel, setRowModesModel] = useState({});
  const [rowForm, setRowForm] = useState({});
  const [rowData, setRowData] = useState(rows);
  const [applicationListDialogInfo, setApplicationListDialogInfo] = useState(
    {},
  );
  const getApplicationListString = (listArr = []) => listArr?.join(",");

  const rowFormHandler = (value, key) => {
    setRowForm((prev) => ({ ...prev, [key]: value }));
  };

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
    setRowForm({
      ...form,
      itemType: dropdownData?.itemTypes?.find(
        (el) => el?.label === form?.itemType,
      ),
    });
  };

  const stopEditing = () => {
    const currForm = { ...rowForm };
    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const handleCancelClick = async (params) => {
    if (params?.row?.isNew) {
      setRowData(rows);
      setRowForm({});
    } else {
      stopEditing(params?.id);
    }
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const addNewRow = async () => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      let randomId = generateRandomId();
      let emptyRow = {
        ...newRow,
        isNew: true,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
    }
  };

  const handleSaveClick = async (params) => {
    createUpdateHandler(rowForm);
  };

  useImperativeHandle(ref, () => ({
    addNewRow: addNewRow,
    startEditing: startEditing,
    stopEditing: stopEditing,
  }));

  const isFormDisabled = !forPANIndia && !rowForm?.isNew;

  const columns = [
    new AGridColDef("academicCareer", "Career*", false)
      .setMinWidth(80)
      .setFlex(0.5)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.academicCareer}
            handleChange={(value) => {
              rowFormHandler(value, "academicCareer");
            }}
            items={dropdownData?.allActiveCareers}
            isMulti={false}
            //   style={selectStyles}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isDisabled={isFormDisabled}
          />
        </div>
      )),

    new AGridColDef("chargeModConfTermMappings", "Term*", false)
      .setMinWidth(150)
      .editable(true)
      .renderCellComponent((params) =>
        params?.value?.length ? (
          <>
            <Tooltip title={params.value?.map((obj) => obj.label).join(", ")}>
              <div className="ellipsis-text">
                {params.value?.map((obj) => obj.label).join(", ")}
              </div>
            </Tooltip>
          </>
        ) : (
          <div>-</div>
        ),
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.chargeModConfTermMappings}
            handleChange={(value) => {
              rowFormHandler(value, "chargeModConfTermMappings");
            }}
            items={dropdownData?.allActiveTerm}
            isMulti={true}
            isShowCount
            //   style={selectStyles}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isDisabled={isFormDisabled}
          />
        </div>
      )),

    new AGridColDef(
      "chargeModConfCourseCategoryMappings",
      "Course Category*",
      false,
    )
      .setMinWidth(180)
      .editable(true)
      .renderCellComponent((params) =>
        params?.value?.length ? (
          <>
            <Tooltip title={params.value?.map((obj) => obj.label).join(", ")}>
              <div className="ellipsis-text">
                {params.value?.map((obj) => obj.label).join(", ")}
              </div>
            </Tooltip>
          </>
        ) : (
          <div>-</div>
        ),
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.chargeModConfCourseCategoryMappings}
            handleChange={(value) => {
              rowFormHandler(value, "chargeModConfCourseCategoryMappings");
            }}
            items={dropdownData?.allCourseCategory}
            isMulti={true}
            isShowCount
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isDisabled={isFormDisabled}
          />
        </div>
      )),

    ...(!forPANIndia
      ? [
          new AGridColDef("businessArea", "BU Code*", false)
            .setMinWidth(100)
            .setFlex(0.5)
            .editable(true)
            .renderCellComponent((params) => (
              <div>
                <span>{params.value?.label}</span>&nbsp;
                <Tooltip title={params?.value?.businessAreaDesc}>
                  <span>
                    <EyeIcon />
                  </span>
                </Tooltip>
              </div>
            ))
            .renderEditCellComponent((params) => (
              <div style={editCellContainerStyle}>
                <AAutoComplete
                  currentValue={rowForm?.businessArea}
                  handleChange={(value) => {
                    rowFormHandler(value, "businessArea");
                  }}
                  items={dropdownData?.allActiveBu}
                  isMulti={false}
                  //   style={selectStyles}
                  placeholder={"Select"}
                  autoFocus={params?.hasFocus}
                  isDisabled={isFormDisabled}
                />
              </div>
            )),
        ]
      : []),

    new AGridColDef("postCourseStartDays", "Modify upto no. of Days*", false)
      .setMinWidth(110)
      .setFlex(0.9)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? <div>{`${params.value} Days`}</div> : <div>-</div>,
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.postCourseStartDays}
            handler={(val) => {
              if (val === "" || val === null) {
                rowFormHandler("", "postCourseStartDays");
              } else if (val > 0 && val <= 1000) {
                rowFormHandler(val, "postCourseStartDays");
              }
            }}
            placeholder={"1000"}
            maxLength={100}
            disabled={isFormDisabled}
            // regex={/^(?:[0-9]{1,3}|1000)?$/}
          />
        </div>
      )),

    new AGridColDef("modLimit", "Modification Frequency*", false)
      .setMinWidth(110)
      .setFlex(0.9)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.modLimit}
            handler={(val) => {
              if (val === "" || val === null) {
                rowFormHandler("", "modLimit");
              } else if (val > 0 && val <= 20) {
                rowFormHandler(val, "modLimit");
              }
            }}
            placeholder={"20"}
            maxLength={100}
            disabled={isFormDisabled}
            // regex={/^(?:[0-9]|[1][0-9]|20)?$/}
          />
        </div>
      )),

    new AGridColDef("ticketId", "Ticket ID*", false)
      .setMinWidth(110)
      .setFlex(0.6)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.ticketId}
            handler={(val) => rowFormHandler(val, "ticketId")}
            placeholder={""}
            maxLength={100}
            regex={regex.ticketDescription}
            disabled={isFormDisabled}
          />
        </div>
      )),

    new AGridColDef("description", "Description*", false)
      .setMinWidth(80)
      .setFlex(0.5)
      .editable(true)
      .setValueGetter((params) => params?.row?.description)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.description}
            handler={(val) => rowFormHandler(val, "description")}
            placeholder={"Charge Modi"}
            maxLength={100}
            disabled={isFormDisabled}
          />
        </div>
      )),

    new AGridColDef("updatedOn", "Last Updated On", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(0.7)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip
              title={`${moment(params?.row?.updatedOn).format(
                "DD MMM YYYY HH:mm A",
              )} by ${params.row.updatedBy}`}
            >
              <div className={`ellipsis-text-container`}>{`${moment(
                params?.row?.updatedOn,
              ).format("DD MMM YYYY HH:mm A")} by ${
                params.row.updatedBy
              }`}</div>
            </Tooltip>
          </>
        ) : (
          <div>-</div>
        ),
      ),

    ...(!forPANIndia
      ? [
          new AGridColDef("applicationLevel", "App. Level", false)
            .setMinWidth(100)
            .setFlex(0.6)
            .columnAlign("center")
            .editable(true)
            .renderCellComponent((params) => (
              <AToggleButton
                toggleOptions={applicationLevelToggleOptions}
                value={params?.value}
              />
            ))
            .renderEditCellComponent((params) => (
              <AToggleButton
                toggleOptions={applicationLevelToggleOptions}
                value={rowForm?.applicationLevel}
                disabled={isFormDisabled}
                handleChange={(val) => rowFormHandler(val, "applicationLevel")}
              />
            )),

          new AGridColDef("applicationList", "App. List", false)
            .setMinWidth(100)
            .setFlex(0.6)
            .columnAlign("center")
            .editable(true)
            .renderCellComponent((params) => (
              <AButton
                variant="link"
                size="xs"
                onClick={() =>
                  setApplicationListDialogInfo({
                    isOpen: true,
                    viewOnly: true,
                    initialApplicationList: getApplicationListString(
                      params?.value,
                    ),
                  })
                }
              >
                View
              </AButton>
            ))
            .renderEditCellComponent((params) => (
              <AButton
                variant="link"
                size="xs"
                disabled={
                  rowForm?.applicationLevel === "NO" || !params?.row?.isNew
                }
                onClick={() =>
                  setApplicationListDialogInfo({
                    isOpen: true,
                    initialApplicationList: getApplicationListString(
                      rowForm?.applicationList,
                    ),
                  })
                }
              >
                {!rowForm?.applicationList?.length ? "Add" : "Edit"}
              </AButton>
            )),
        ]
      : []),

    ...(forPANIndia
      ? [
          new AGridColDef("dateControl", "Date Control", false)
            .setMinWidth(170)
            .setFlex(1)
            .editable(true)
            .renderCellComponent((params) => <span>{params.value?.label}</span>)
            .renderEditCellComponent((params) => (
              <div style={editCellContainerStyle}>
                <AAutoComplete
                  currentValue={rowForm?.dateControl}
                  handleChange={(value) => {
                    rowFormHandler(value, "dateControl");
                  }}
                  items={dateControlDropdown}
                  isMulti={false}
                  placeholder={"Select"}
                  autoFocus={params?.hasFocus}
                  isDisabled={isFormDisabled}
                />
              </div>
            )),
        ]
      : []),

    new AGridColDef("status", "Status", false)
      .setMinWidth(80)
      .setFlex(0.6)
      .columnAlign("center")
      .editable(true)
      .renderCellComponent((params) => (
        <StatusCellComponent value={params.value} />
      ))
      .renderEditCellComponent((params) => (
        <StatusCellComponent
          value={rowForm?.status}
          handleChange={(val) => rowFormHandler(val, "status")}
        />
      )),

    new AGridColDef("actions", "Action", false)
      .setMinWidth(120)
      .setFlex(0.7)
      .editable(true)
      .columnAlign("center")
      .renderCellComponent((params) => (
        <>
          <ActionsCellComponent
            mode={params.api.getRowMode(params?.id)}
            handleEditClick={handleEditClick}
            params={params}
          />
        </>
      ))
      .renderEditCellComponent((params) => (
        <>
          <ActionsCellComponent
            mode={"edit"}
            isSaveDisabled={
              !rowForm?.ticketId ||
              !rowForm?.description ||
              !rowForm?.academicCareer ||
              !rowForm?.postCourseStartDays ||
              !rowForm?.modLimit ||
              (!forPANIndia && !rowForm?.businessArea) ||
              (forPANIndia && !rowForm?.dateControl)
            }
            handleSaveClick={handleSaveClick}
            handleCancelClick={handleCancelClick}
            params={params}
            cancelIcon={
              <CloseIcon
                className="mx-2 cursor"
                onClick={() => handleCancelClick(params)}
              />
            }
          />
        </>
      )),
  ];

  useEffect(() => {
    setRowData(rows);
  }, [rows]);

  return (
    <>
      {loading && <ALoader position="fixed" />}
      <ADataGrid
        removeWrapperContainer
        autoHeight
        sx={{
          ...gridStyles,
        }}
        rowModesModel={rowModesModel}
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={totalRecords}
        currentPage={currentPage}
        nextButtonHandler={pageChangeHandler}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={loading ? "Loading..." : null} />
          ),
        }}
      />

      <AddApplicationListPopup
        dialogInfo={applicationListDialogInfo}
        setDialogInfo={setApplicationListDialogInfo}
        rowFormHandler={rowFormHandler}
        key={JSON.stringify(applicationListDialogInfo)}
      />
    </>
  );
};

export default forwardRef(ListComponent);
